import Button from "@src/components/Button"

interface AccountHeaderProps {
  firstName: string
  onSignOut: () => void
}
export default function AccountHeader({
  firstName,
  onSignOut,
}: AccountHeaderProps) {
  return (
    <header className="mt-6 mb-4 md:mb-8 md:flex md:items-center md:justify-between">
      <h1 className="font-browser text-2xl font-medium">Hello {firstName}!</h1>
      <div className="text-sm">
        Not {firstName}?{" "}
        <Button onClick={() => onSignOut()} text="Sign Out" type="inlineLink" />
      </div>
    </header>
  )
}
